import { Dot } from "components/Dot";
import LinkShowToTravelButton, { type LinkShowToTravelConfig } from "components/LinkShowToTravelButton";
import LinkedShowLines from "components/LinkedShows/LinkedShowElement";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { ShowSidePanel } from "components/SidePanel/Show/ShowSidePanel";
import Table from "components/Tables/Table";
import React from "react";

interface Props {
  linkedShows: server.dto.LinkedShow[];
  linkShowToTravel: LinkShowToTravelConfig
}

export const LinkedShowSimplePanel = (props: Props) => {
  const renderLinkShowToTravelButton = () => {
    const linkShowToTravel = props.linkShowToTravel;

    if (linkShowToTravel == null || !linkShowToTravel.canLink) {
      return undefined;
    }

    return <LinkShowToTravelButton
      travelType={linkShowToTravel.travelType}
      travelId={linkShowToTravel.travelId}
      appointmentDateTime={linkShowToTravel.appointmentDateTime}
      artist={linkShowToTravel.artist}
      linkedShowIds={linkShowToTravel.linkedShowIds}
      onLinked={linkShowToTravel.onLinked}
    />;
  };

  return <SectionPanel.Panel
    key="linkedShows"
    header={<>
      <PanelSegment.Title title={site.currentEnvironment.show.plural} />
    </>}
    button={renderLinkShowToTravelButton()}
  >
    <Table
      items={props.linkedShows}
      isLoading={false}
      getKey={show => show.showId.toString()}
      hideHeader
      columns={[{
        key: "linkedShowLines",
        header: "",
        render: (show) => <ShowSidePanel
          canEdit
          showId={show.showId}
          key={show.showId}
          trigger={<a className="flex gap-small linked-show-row linked-show-link regular" style={{ cursor: "pointer", textDecoration: "none" }}>
            <div>
              <Dot color={show.status.hexColor} />
            </div>
            <div>
              <LinkedShowLines {...show} format={"regular"} />
            </div>
          </a>}
        />,
        size: "1fr"
      }]}
    />
  </SectionPanel.Panel>
}
